import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ClientDevice } from '@prism/prism-shared';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-client-device-information-dialog',
  templateUrl: './client-device-information-dialog.component.html',
  styleUrls: ['./client-device-information-dialog.component.scss'],
})
export class ClientDeviceInformationDialogComponent implements OnInit, OnDestroy {

  @Input() submitPressed$!: Subject<string | undefined>
  @Input() args!: ClientDeviceInformationDialogComponent;

  public clientDevice!: ClientDevice;


  private unsubscribe$: Subject<void> = new Subject<void>();

  constructor(
  ) { }

  ngOnInit(): void {

    this.clientDevice = this.args.clientDevice;

    if (!this.clientDevice) {
      throw new Error('Client device is required');
    }


  }


  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }


  public refresh() {
    // perform the equivalent of an ctrl + F5
    window.location.reload();

  }


}
